import { render, staticRenderFns } from "./GameUI.vue?vue&type=template&id=4a73cca2&scoped=true&"
import script from "./GameUI.vue?vue&type=script&lang=ts&"
export * from "./GameUI.vue?vue&type=script&lang=ts&"
import style0 from "./GameUI.vue?vue&type=style&index=0&id=4a73cca2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a73cca2",
  null
  
)

export default component.exports